<template>
  <div class="app-container">
    <el-form :model="searchData" :inline="true" label-width="140px" label-position="right" ref="searchData">
      <el-form-item label="统计日期" prop="totalDate">
        <!-- 按日选择 -->
        <el-date-picker
          :key="'day-picker'"
          v-model="totalDate"
          type="daterange"
          :picker-options="dayPickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          @change="handleDayChange"
          :clearable="false"
        />
      </el-form-item>

      <el-form-item label="省" prop="provinceId">
        <el-select v-model="searchData.provinceId" placeholder="请选择" clearable style="width: 100%" @change="provinceChangeFun">
          <el-option v-for="item in provinceListNew" :key="item.provinceId" :label="item.province" :value="item.provinceId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="市" prop="cityId">
        <el-select v-model="searchData.cityId" placeholder="请选择" clearable style="width: 100%" @change="cityChangeFun" :disabled="!searchData.provinceId">
          <el-option v-for="item in cityListNew" :key="item.cityId" :label="item.city" :value="item.cityId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区" prop="countyId">
        <el-select v-model="searchData.countyId" placeholder="请选择" clearable style="width: 100%" @change="countyChangeFun" :disabled="!searchData.cityId">
          <el-option v-for="item in districtListNew" :key="item.countyId" :label="item.county" :value="item.countyId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="btn-group">
      <div class="row-bg">
        <el-button ghost size="medium" @click="exportBtnFun" :loading="exportFlag">导出</el-button>
      </div>
      <el-alert style="margin: 0 16px;" :title="`检索出${total}条数据, 旧机价值总计: ${totalPrice}`" type="success" show-icon :closable="false"> </el-alert>
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
      </div>
    </div>

    <el-table ref="checktableData" :data="tableData" v-loading="tableLoading" :reserve-selection="true" center height="60vh">
      <el-table-column label="操作" prop="action" width="140">
        <template slot-scope="scope">
          <el-link type="primary" @click="openTotalPriceUpdateModal(scope.row)" v-if="scope.row.status != 1">修改</el-link>
          <el-link style="margin-left: 12px;" type="primary" @click="handleSave(scope.row)" v-if="scope.row.status != 1">存档</el-link>
        </template>
      </el-table-column>
      <el-table-column label="统计日期" prop="totalDate" min-width="100"></el-table-column>
      <el-table-column label="省" prop="province" min-width="100"></el-table-column>
      <el-table-column label="市" prop="city" min-width="100"></el-table-column>
      <el-table-column label="区" prop="county" min-width="100"></el-table-column>
      <el-table-column label="挂机价值" prop="airConditionerWallHangingPrice" min-width="100"></el-table-column>
      <el-table-column label="挂机数量" prop="airConditionerWallHangingCount" min-width="100"></el-table-column>
      <el-table-column label="柜机价值" prop="airConditionerPackagedPrice" min-width="100"></el-table-column>
      <el-table-column label="柜机数量" prop="airConditionerPackagedCount" min-width="100"></el-table-column>

      <el-table-column label="空气能热水器价值" prop="airEnergyWaterHeaterPrice" min-width="100"></el-table-column>
      <el-table-column label="空气能热水器数量" prop="airEnergyWaterHeaterCount" min-width="100"></el-table-column>
      <el-table-column label="电热水器价值" prop="electricWaterHeaterPrice" min-width="100"></el-table-column>
      <el-table-column label="电气热水器数量" prop="electricWaterHeaterCount" min-width="100"></el-table-column>
      <el-table-column label="燃气热水器价值" prop="gasWaterHeaterPrice" min-width="100"></el-table-column>
      <el-table-column label="燃气热水器数量" prop="gasWaterHeaterCount" min-width="100"></el-table-column>
      <el-table-column label="滚筒洗衣机价值" prop="washingMachineDrumPrice" min-width="100"></el-table-column>
      <el-table-column label="滚筒洗衣机数量" prop="washingMachineDrumCount" min-width="100"></el-table-column>
      <el-table-column label="波轮全自动洗衣机价值" prop="washingMachineTumblePrice" min-width="100"></el-table-column>
      <el-table-column label="波轮全自动洗衣机数量" prop="washingMachineTumbleCount" min-width="100"></el-table-column>
      <el-table-column label="双缸洗衣机价值" prop="washingMachineDoublePrice" min-width="100"></el-table-column>
      <el-table-column label="双缸洗衣机数量" prop="washingMachineDoubleCount" min-width="100"></el-table-column>
      <el-table-column label="洗碗机价值" prop="dishwasherPrice" min-width="100"></el-table-column>
      <el-table-column label="洗碗机数量" prop="dishwasherCount" min-width="100"></el-table-column>
      <el-table-column label="液晶价值" prop="televisionOnePrice" min-width="100"></el-table-column>
      <el-table-column label="液晶数量" prop="televisionOneCount" min-width="100"></el-table-column>
      <el-table-column label="CRT价值" prop="televisionTwoPrice" min-width="100"></el-table-column>
      <el-table-column label="CRT数量" prop="televisionTwoCount" min-width="100"></el-table-column>
      <el-table-column label="液晶（32寸及以上）价值" prop="televisionThreePrice" min-width="100"></el-table-column>
      <el-table-column label="液晶（32寸及以上）数量" prop="televisionThreeCount" min-width="100"></el-table-column>
      <el-table-column label="CRT(19寸及以上)价值" prop="televisionFourPrice" min-width="100"></el-table-column>
      <el-table-column label="CRT(19寸及以上)数量" prop="televisionFourCount" min-width="100"></el-table-column>
      <el-table-column label="冷柜价值" prop="freezerPrice" min-width="100"></el-table-column>
      <el-table-column label="冷柜数量" prop="freezerCount" min-width="100"></el-table-column>
      <el-table-column label="双门（100L以上）价值" prop="fridgeOnePrice" min-width="100"></el-table-column>
      <el-table-column label="双门（100L以上）数量" prop="fridgeOneCount" min-width="100"></el-table-column>
      <el-table-column label="冰箱（100升以上）价值" prop="fridgeTwoPrice" min-width="100"></el-table-column>
      <el-table-column label="冰箱（100升以上）数量" prop="fridgeTwoCount" min-width="100"></el-table-column>
      <el-table-column label="多门（100L以上）价值" prop="fridgeThreePrice" min-width="100"></el-table-column>
      <el-table-column label="多门（100L以上）数量" prop="fridgeThreeCount" min-width="100"></el-table-column>
      <el-table-column label="酒柜价值" prop="fridgeFourPrice" min-width="100"></el-table-column>
      <el-table-column label="酒柜数量" prop="fridgeFourCount" min-width="100"></el-table-column>
      <el-table-column label="旧机总价值" prop="totalPrice" min-width="100"></el-table-column>
      <el-table-column label="旧机总数量" prop="totalCount" min-width="100"></el-table-column>
      <el-table-column label="更新时间" prop="lastModifiedDate" min-width="200"></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="pagination.page"
        :page-size="pagination.rows"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
      >
      </el-pagination>
    </div>
    <total-price-update-modal ref="totalPriceUpdateModalRef" @submit="handleSearch()" @getList="handleSearch()"></total-price-update-modal>
  </div>
</template>
<script>
import jdProvinceCity from '@/views/jdOldMachineRecycleManage/mixins/jdProvinceCity.js'
import totalPriceUpdateModal from './components/TotalPriceUpdateModal.vue'
import dayjs from 'dayjs'

export default {
  mixins: [jdProvinceCity],
  components: {
    totalPriceUpdateModal
  },
  data() {
    return {
      searchData: {
        provinceId: undefined,
        cityId: undefined,
        countyId: undefined,
        startTotalDate: undefined,
        endTotalDate: undefined
      },
      totalDate: [this.getCurrentDate(), this.getCurrentDate()],
      tableData: [],
      oldMachineEnum: [],
      provinceListNew: [],
      cityListNew: [],
      districtListNew: [],
      total: 0,
      pagination: {
        page: 1,
        rows: 10
      },
      tableLoading: false,
      selectList: [],
      exportFlag: false,
      totalPrice: 0,
      dayPickerOptions: {
        disabledDate: time => {
          const today = dayjs().startOf('day')
          return dayjs(time).isAfter(today, 'day')
        },
        onPick: ({ maxDate, minDate }) => {
          if (maxDate) {
            const diffDays = dayjs(maxDate).diff(dayjs(minDate), 'day')
            if (diffDays > 365) {
              this.totalDate = [this.getCurrentDate(), this.getCurrentDate()]
              this.$message.warning('最多只能选择1年')
            }
          }
        }
      }
    }
  },
  mounted() {
    this.getTblProvinceNew()
    this.handleSearch()
  },
  methods: {
    // 获取当前日期
    getCurrentDate() {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // 省改变
    provinceChangeFun() {
      this.searchData.cityId = undefined
      this.searchData.countyId = undefined
      const selectedProvince = this.provinceListNew.find(item => item.provinceId === this.searchData.provinceId)
      this.searchData.province = selectedProvince ? selectedProvince.province : undefined
      this.getTblCityNew(this.searchData.provinceId)
    },
    // 市改变
    cityChangeFun() {
      this.searchData.countyId = undefined
      const selectedCity = this.cityListNew.find(item => item.cityId === this.searchData.cityId)
      this.searchData.city = selectedCity ? selectedCity.city : undefined
      this.getTblCountyNew(this.searchData.provinceId, this.searchData.cityId)
    },
    // 区县改变
    countyChangeFun() {
      const selectedCounty = this.districtListNew.find(item => item.countyId === this.searchData.countyId)
      this.searchData.county = selectedCounty ? selectedCounty.county : undefined
    },
    //获取列表
    getList() {
      const url = `/autoapp-default-server-recovery/api/settlement/jdTotal/pageCondition`
      const params = {
        ...this.searchData,
        ...this.pagination
      }
      params.startTotalDate = dayjs(this.totalDate[0]).format('YYYY-MM-DD')
      params.endTotalDate = dayjs(this.totalDate[1]).format('YYYY-MM-DD')
      return this.HttpService.post(url, this.global.clearEmptyParam(params)).then(res => {
        if (res.statusCode === 200) {
          this.total = res.data.total || 0
          const resData = res.data.records || []
          this.tableData = resData
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },

    // 查询
    handleSearch() {
      this.pagination.page = 1
      this.getList()
      this.getTotalPrice()
    },
    // 清空
    resetForm() {
      // 重置搜索条件
      Object.assign(this.searchData, {
        startTotalDate: undefined,
        endTotalDate: undefined,
        province: undefined,
        city: undefined,
        recycler: undefined
      })
      this.totalDate = [this.getCurrentDate(), this.getCurrentDate()]
      this.getList()
    },
    // 页码改变
    handleSizeChange(val) {
      this.pagination.page = 1
      this.pagination.rows = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    // 导出
    exportBtnFun() {
      this.exportFlag = true
      setTimeout(() => {
        this.exportFlag = false
      }, 1200)
      const url = '/autoapp-default-server-recovery/api/settlement/jdTotal/exportPageCondition'
      const title = '旧机结算统计数据(京东)'
      const params = {
        ...this.searchData
      }
      params.startTotalDate = dayjs(this.totalDate[0]).format('YYYY-MM-DD')
      params.endTotalDate = dayjs(this.totalDate[1]).format('YYYY-MM-DD')
      this.HttpService.post(url, this.global.clearEmptyParam(params)).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },

    openTotalPriceUpdateModal(row) {
      const { id } = row
      this.$refs.totalPriceUpdateModalRef.openDialog(row)
    },
    handleSave(row) {
      const { id } = row
      const url = `/autoapp-default-server-recovery/api/settlement/jdTotal/archive`
      return this.HttpService.post(url, { id: id }).then(res => {
        if (res.statusCode === 200) {
          this.$message.success('存档成功')
          this.getList()
        } else {
          const msgTip = res.message || '请求出错, 请重试'
          this.$message.error(msgTip)
        }
      })
    },
    getTotalPrice() {
      const url = `/autoapp-default-server-recovery/api/settlement/jdTotal/totalPricePageCondition`
      const params = {
        ...this.searchData,
        ...this.pagination
      }
      params.startTotalDate = dayjs(this.totalDate[0]).format('YYYY-MM-DD')
      params.endTotalDate = dayjs(this.totalDate[1]).format('YYYY-MM-DD')
      return this.HttpService.post(url, this.global.clearEmptyParam(params)).then(res => {
        if (res.statusCode === 200) {
          this.totalPrice = res.data || 0
        }
      })
    },

    handleDayChange(dates) {
      if (dates && dates.length === 2) {
        const diffDays = dayjs(dates[1]).diff(dayjs(dates[0]), 'day')
        if (diffDays > 365) {
          this.totalDate = []
        }
      }
      this.searchData.startTotalDate = dayjs(dates[0]).format('YYYY-MM-DD')
      this.searchData.endTotalDate = dayjs(dates[1]).format('YYYY-MM-DD')
    }
  }
}
</script>
<style scoped lang="scss">
.row-bg {
  padding: 10px 0;
  display: flex;
  align-items: center;
}
.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/settlementManagement/oldMachineSettlementJD.vue